import { render, staticRenderFns } from "./Likes.vue?vue&type=template&id=1daa3281"
import script from "./Likes.vue?vue&type=script&lang=js"
export * from "./Likes.vue?vue&type=script&lang=js"
import style0 from "./Likes.vue?vue&type=style&index=0&id=1daa3281&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports